module.exports = __webpack_public_path__ + "static/media/02.49fb03c1.mp3";